import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TypeService } from '../../../../services/type/type-service';
import { EmployerRecordFormFactory } from '../../../../form-factories/employer-record-form-factory';
import { map } from 'rxjs/operators';
import { PhoneDropdownItem } from '../../../../models/shared/phone-dropdown-item';

@Component({
  selector: 'app-employer-record-add-primary-contact-modal',
  templateUrl: './employer-record-add-primary-contact-modal.component.html',
  styleUrls: ['./employer-record-add-primary-contact-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerRecordAddPrimaryContactModalComponent {
  private ngbModal = inject(NgbActiveModal);
  private typeService = inject(TypeService);

  public formGroup = EmployerRecordFormFactory.buildEmployerPrimaryContactFormGroup();
  public formSubmitted = false;

  public countryCodeDropdowns$ = this.typeService.countries$.pipe(
    map(countries => countries?.map(c => new PhoneDropdownItem(c)))
  );

  public cancel(): void {
    this.ngbModal.close();
  }

  public addContact(): void {
    this.formSubmitted = true;

    if (this.formGroup.valid) {
      this.ngbModal.close(this.formGroup);
    }
  }
}
